export default __webpack_public_path__ + "static/media/default-image.475b7a4e.png";